import { Injectable } from '@angular/core';
import { Applicant } from '@app/models/recruiting/applicant.model';
import { Interview } from '@app/models/recruiting/interview.model';
import { JobPosting } from '@app/models/recruiting/job-posting.model';

@Injectable()
export class ManageInterviewService {
    selectedApplicants: Applicant[] = [];
    jobPosting: JobPosting;
    interview: Interview;
}
